import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.packing.title',
    defaultMessage: 'Packing',
    description: 'title of the packing page',
  },
  search: {
    placeholder: {
      id: 'pages.packing.search.placeholder',
      defaultMessage: 'Shipment number',
      description: 'Placeholder of the search bar on the packing page',
    },
  },
  emptyMessage: {
    list: {
      id: 'pages.packing.emptyMessage.list',
      defaultMessage: 'All shipments are packed',
      description: 'Empty message when using a handling list on the packing page',
    },
    shipments: {
      id: 'pages.packing.emptyMessage.shipments',
      defaultMessage: 'No shipments found',
      description: 'Empty message on the packing page',
    },
  },
  backToShipments: {
    id: 'pages.packing.backToShipments',
    defaultMessage: 'Back to shipments',
    description: 'Button for going back to the shipments page from the packing page',
  },
  feedback: {
    shipmentAlreadyBoxed: {
      id: 'pages.packing.feedback.shipmentAlreadyBoxed',
      defaultMessage: 'Shipment already boxed',
      description: 'Shipment already boxed feedback message',
    },
  },
};

export default defineMessages(translations);
